import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Navigate as Redirect } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isNil } from 'lodash'
import actions from '../../actions/Users'
import carrierBrandActions from '../../actions/CarrierBrands'
import platformActions from '../../actions/Platforms'
import alert from '../../alert'
import CarrierUserForm from './CarrierUserForm'

export class CarrierUserCreate extends Component {
  static propTypes = {
    create: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    generalError: PropTypes.string,
    resourceErrors: PropTypes.object,
    created: PropTypes.bool.isRequired,
    id: PropTypes.number,
    requestInProgress: PropTypes.bool.isRequired,
    carrierBrands: PropTypes.array,
    indexCarrierBrands: PropTypes.func.isRequired,
    resetCarrierBrands: PropTypes.func.isRequired,
    platforms: PropTypes.array,
    indexPlatforms: PropTypes.func.isRequired,
    resetPlatforms: PropTypes.func.isRequired,
    platformsRequestInProgress: PropTypes.bool.isRequired,
    carrierBrandsRequestInProgress: PropTypes.bool.isRequired
  }

  componentWillUnmount() {
    this.props.reset()
  }

  handleSubmit = (values, dispatch) => {
    this.props.create(this.translateValues(values))
  }

  translateValues = (values) => {
    const newValues = cloneDeep(values)

    if (!isNil(newValues.carrier_brands)) {
      newValues.carrier_brands = newValues.carrier_brands.map((carrierBrandId) => ({
        carrier_brand_id: carrierBrandId
      }))
    }

    return newValues
  }

  redirect(path) {
    return <Redirect replace to={path} />
  }

  render() {
    const { generalError, resourceErrors } = this.props

    if (!isNil(generalError)) {
      alert(generalError)
    }

    if (this.props.created && !isNil(this.props.id)) {
      return this.redirect(`/carrier_users/${this.props.id}`)
    }

    const errors = isNil(resourceErrors) ? {} : resourceErrors

    return (
      <div className="content">
        <h2>Invite Carrier User</h2>
        <div>
          <CarrierUserForm
            handleSubmit={this.handleSubmit}
            errors={errors}
            requestInProgress={this.props.requestInProgress}
            carrierBrands={this.props.carrierBrands}
            resetCarrierBrands={this.props.resetCarrierBrands}
            carrierBrandsRequestInProgress={this.props.carrierBrandsRequestInProgress}
            indexCarrierBrands={this.props.indexCarrierBrands}
            platforms={this.props.platforms}
            resetPlatforms={this.props.resetPlatforms}
            platformsRequestInProgress={this.props.platformsRequestInProgress}
            indexPlatforms={this.props.indexPlatforms}
            initialValues={{
              user_type: 'carrier',
              username: null,
              email: null,
              carrier_id: null,
              carrier_brands: [],
              carrier_verification_tool: false,
              quote_reporting: false,
              analytics_reporting: false,
              cvt_platforms: []
            }}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const slice = state.users.create
  const carrierBrandsSlice = state.carrierBrands.index
  const platformsSlice = state.platforms.index

  return {
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    requestInProgress: slice.requestInProgress,
    id: slice.id,
    created: slice.created,

    carrierBrands: carrierBrandsSlice.records,
    carrierBrandsRequestInProgress: carrierBrandsSlice.requestInProgress,

    platforms: platformsSlice.records,
    platformsRequestInProgress: platformsSlice.requestInProgress
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  create: actions.create.main,
  reset: actions.create.reset,

  indexCarrierBrands: carrierBrandActions.index.main,
  resetCarrierBrands: carrierBrandActions.index.reset,

  indexPlatforms: platformActions.index.main,
  resetPlatforms: platformActions.index.reset
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CarrierUserCreate)
